import { h as html, D as DOM, a as attr, o as observable } from './vivid-element.js';
import { s as slotted } from './slotted.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
const Anchored = (Base) => {
  class AnchoredElement extends Base {
    /**
     * @internal
     */
    anchorChanged() {
      this.#updateAnchorEl();
    }
    /**
     * @internal
     */
    _slottedAnchorChanged() {
      const isOccupied = Boolean(
        this._slottedAnchor && this._slottedAnchor.length > 0
      );
      DOM.setBooleanAttribute(
        this,
        "slotted-anchor",
        isOccupied
      );
      this.#updateAnchorEl();
    }
    #updateAnchorEl = () => {
      if (!this.isConnected) {
        this._anchorEl = void 0;
        return;
      }
      this.#cleanupObserverIfNeeded();
      let newAnchor = void 0;
      if (this._slottedAnchor && this._slottedAnchor.length > 0) {
        newAnchor = this._slottedAnchor[0];
      } else if (this.anchor instanceof HTMLElement) {
        newAnchor = this.anchor;
      } else if (typeof this.anchor === "string") {
        newAnchor = document.getElementById(this.anchor) ?? void 0;
        if (!newAnchor) {
          this.#observeMissingAnchor(this.anchor);
        }
      }
      this._anchorEl = newAnchor;
    };
    #observer;
    #observeMissingAnchor = (anchorId) => {
      this.#observer = new MutationObserver(() => {
        const anchor = document.getElementById(anchorId);
        if (anchor) {
          this._anchorEl = anchor;
          this.#cleanupObserverIfNeeded();
        }
      });
      this.#observer.observe(document.body, { childList: true, subtree: true });
    };
    #cleanupObserverIfNeeded = () => {
      this.#observer?.disconnect();
      this.#observer = void 0;
    };
    connectedCallback() {
      super.connectedCallback();
      this.#updateAnchorEl();
    }
    disconnectedCallback() {
      super.disconnectedCallback();
      this.#cleanupObserverIfNeeded();
      this._anchorEl = void 0;
    }
  }
  __decorateClass([
    attr
  ], AnchoredElement.prototype, "anchor");
  __decorateClass([
    observable
  ], AnchoredElement.prototype, "_slottedAnchor");
  __decorateClass([
    observable
  ], AnchoredElement.prototype, "_anchorEl");
  return AnchoredElement;
};
const anchorSlotTemplateFactory = () => html`<slot
		name="anchor"
		${slotted("_slottedAnchor")}
	></slot>`;

export { Anchored as A, anchorSlotTemplateFactory as a };
